export default __webpack_public_path__ + "static/media/shaheen.24eccc71.jpg";